'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stopBotTyping = undefined;

var _reduxActions = require('redux-actions');

var _typingIndicatorActionTypes = require('../constants/typingIndicatorActionTypes');

var stopBotTyping = exports.stopBotTyping = (0, _reduxActions.createAction)(_typingIndicatorActionTypes.STOP_BOT_TYPING, function (threadId, botId) {
  return { threadId: threadId, botId: botId };
});


//////////////////
// WEBPACK FOOTER
// ./js/typing-indicators/actions/stopBotTyping.js
// module id = 597
// module chunks = 2 3